import { Location } from '@angular/common';
import { ApplicationRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AnalyticsFacade } from '@amfam/shared/analytics';
import { BillingAnalytics } from '@amfam/shared/models';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { PartnerTermsData } from '@amfam/shared/utility/shared-services';
import { DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../core/store';
import { TermsComponentDirective } from '../terms.component';

@Component({
  selector: '',
  templateUrl: './bill-account-terms.component.html',
  styleUrls: ['./bill-account-terms.component.scss'],
  standalone: false
})
export class BillAccountTermsComponent extends TermsComponentDirective implements OnInit {
  public termsPartnerData$: Observable<PartnerTermsData> = this.store.select(
    BrandSelectors.selectPartnerTermsData
  );

  constructor(
    private store: Store<fromRoot.RootState>,
    dockingService: DockingBarService,
    route: ActivatedRoute,
    application: ApplicationRef,
    private pageTitle: PageTitleService,
    private analyticsFacade: AnalyticsFacade,
    private location: Location
  ) {
    super(dockingService, route, application);
  }

  ngOnInit() {
    const title = 'Billing Terms & Conditions';
    this.dockingService.registerHeading(title);
    this.pageTitle.set(title);
    this.analyticsFacade.trackPage(BillingAnalytics.pageTermsAndConditions);
    super.ngOnInit();
  }

  public back() {
    this.location.back();
  }
}
